



















import { Component, Vue } from 'vue-property-decorator';
import PluginComponent from '../PluginComponent';
import { EventBus, EVENTS } from '@/services/EventBus';
import LayerConfig from '@/models/map-context/LayerConfig';
import axios from 'axios';
import { GeoJSON } from 'ol/format';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import sanitizeHtml from 'sanitize-html';
import Filter from '@/models/map-context/filter/Filter';

@Component<FeatureInfosCreatePanelCustom>({
  props: {

  },
  components: {

  },
})

export default class FeatureInfosCreatePanelCustom extends PluginComponent {
  static ID='FeatureInfosCreatePanelCustom';

  static NAME='FeatureInfosCreatePanelCustom';

  private currentFeature:any;

  isFeatureSelected = false;

  idoc=51;

  public keys = Array<any>();


  plugins: Plugin[] = [];

  public layerOfFeature: LayerConfig|null=null;

  public edition = false;

  public width = 0;


  public urlApi="";
  public urlMetier="";

  public urlOriginIframe="";

  public serviceApi="";

  public serviceApiEdit="";

  public infosContent = '';

  public keysForEdition = Array<any>();

  public isAccordionOpen: boolean = false;


  openOnSelectedFeature(features:any):boolean{
      return true;

  }




  beforeDestroy():void {
    EventBus.$off(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    EventBus.$off(EVENTS.CHANGE_FEATURE, this.onChangeFeature);

  }

  created() {
    console.log('created');
  }

  mounted() {

    console.log('hide app-header');
    const mapDiv:any = document.getElementById('app-header');
    if (mapDiv){
      mapDiv.style.display = 'none';
    }

    const plugin = this.pluginService.getByName(FeatureInfosCreatePanelCustom.NAME); //FeatureInfosPanelCustom
    if (plugin){
       this.urlOriginIframe = plugin.getParameterValue('urlOriginIframe');
    }

    EventBus.$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    EventBus.$on(EVENTS.CHANGE_FEATURE, this.onChangeFeature);

    const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    if (selectedFeatures !== undefined) {
      this.onFeatureSelected(selectedFeatures);
    }




  }

  onChangeFeature(feature: any) {
    this.onFeatureSelected([feature]);
  }

  onFeatureSelected(features: any) {
    console.log("onFeatureSelected3qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");

      this.currentFeature = features[0];
      this.isFeatureSelected = true;

      // this.getMapService().selectionService.cleanSelection();
      // this.getMapService().selectionService.addToSelection(this.currentFeature);

      //this.parseFeature();
    }


  //   parseFeature() {
  //   if (this.currentFeature) {


  //     if (this.currentFeature) {
  //       this.layerOfFeature = this.currentFeature.layerConfig;
  //       if (this.layerOfFeature && this.layerOfFeature.editing) {
  //         this.edition = true;
  //       }
  //       if (this.layerOfFeature && this.layerOfFeature.ficheInfos.width && this.layerOfFeature.ficheInfos.width>=20 && this.layerOfFeature.ficheInfos.width<=100) {
  //         this.width = this.layerOfFeature.ficheInfos.width;
  //       } else {
  //         this.width = 0;
  //       }

  //       this.infosContent ='';

  //       if (this.layerOfFeature && this.layerOfFeature.ficheInfos.active) {
  //         const regEx = new RegExp(/{(.*?)}/, 'ig');
  //         let feature=this.currentFeature;
  //         let infosContent =(<string>this.layerOfFeature.ficheInfos.content).replace(regEx, (a:any, b:any) => {
  //           let value = feature ? Filter.evaluateExpression(b, feature.getProperties()) : null;

  //           //if value is a number with lots of decimals, truncate to 3 redmine #21755
  //           if(!isNaN(parseFloat(value)) && isFinite(value)){
  //             value=parseFloat(value);
  //             if( (value+"").indexOf('.')>0){
  //               let nbDecimale = (value+"").split(".")[1].length;
  //               if(nbDecimale>5){
  //                 value=Math.round(value*1000)/1000;
  //               }
  //             }

  //           }

  //           return value != undefined ? value : '';
  //         });
  //         infosContent = sanitizeHtml(infosContent,{
  //           allowedTags: sanitizeHtml.defaults.allowedTags.concat([ 'img' ]),
  //           allowedAttributes: false,
  //           allowedSchemesByTag: {
  //             img: [ 'data','https' ]
  //           }
  //         });
  //         this.infosContent = infosContent;// "<div class='ck-content'>"+popupinfosContent+'</div>';
  //       }
  //     }

  //     let allkeys = [];

  //     if (this.currentFeature.getKeys) {
  //       allkeys = this.currentFeature.getKeys();
  //     } else {
  //       const props = this.currentFeature.getProperties();
  //       for (const p in props) {
  //         allkeys.push(p);
  //       }
  //     }

  //     this.keys = Array<any>();

  //     const self = this;
  //     if (this.layerOfFeature && this.layerOfFeature.layerProperties
  //         && this.layerOfFeature.layerProperties.length > 0) {
  //       const layerProperties = this.layerOfFeature.layerProperties;
  //       this.keysForEdition = layerProperties.filter((x:LayerAttribute): any => x.name !== this.currentFeature.geometryName_ && x.editable);
  //       const cf = this.currentFeature;
  //       this.keysForEdition.forEach((key:any) => {
  //         key.value = self.getValue(key.name);
  //       });
  //       // On sélectionne les clefs d'attributs qu'on veut afficher
  //       allkeys.forEach((key:any): void => {
  //         if (self.shallDisplayKey(key, layerProperties) && self.getValue(key) !== undefined) {
  //           self.keys.push(key);
  //         }
  //       });
  //     } else {
  //       // On en prend que les key dont la valeur existe réellement.
  //       allkeys.forEach((key:any) => {
  //         if (self.getValue(key)) {
  //           self.keys.push(key);
  //         }
  //       });
  //     }

  //     // On retire la géométrie des attributs à montrer
  //     const geomName = this.currentFeature.geometryName_;
  //     if (this.keys.indexOf(geomName) >= 0) {
  //       this.keys.splice(this.keys.indexOf(geomName), 1);
  //     }
  //     const target:any = this.$refs.customContent;
  //     if (this.layerOfFeature && (<any>this.layerOfFeature).featureInfoContentRenderer) {
  //       // eslint-disable-next-line no-unused-expressions
  //       this.layerOfFeature!.featureInfoContentRenderer(self.currentFeature, target);
  //     }
  //   } else {
  //     // reset le panneau de moficiation
  //     this.currentFeature = null;
  //     this.layerOfFeature = null;
  //     this.isFeatureSelected = false;
  //   }
  // }






  // getLabel(key:any) {
  //   if (this.layerOfFeature && this.layerOfFeature.layerProperties) {
  //     const searchAttribute = this.layerOfFeature.layerProperties.filter((data) => data.name === key)[0];
  //     if (searchAttribute !== undefined && searchAttribute.label !== undefined && searchAttribute.label !== '') {
  //       return searchAttribute.label;
  //     }
  //   }

  //   return key;
  // }



  // getValue(key:any) {
  //   // Cesium Entity
  //   if (this.currentFeature.properties) {
  //     return this.currentFeature.properties.getValue()[key];
  //   }
  //   if (this.currentFeature.get(key) === undefined) {
  //     return '';
  //   }
  //   return this.currentFeature.get(key);
  // }

  // shallDisplayKey(key:string, properties:any) {
  //   return properties.filter((el:any) => key === el.name && el.display).length > 0;
  // }


  // getDocUrl(doc:any) {
  //   console.log("fffffffffffffffffffffffffffffffffffffffffffffffffffff");

  //   console.log(doc);
  //   console.log(doc.idDocument);
  //   return this.urlApi + "documents/" + doc.idDocument + "/file";
  // }

  // getDocName(doc:any) {
  //   return doc.cheminStockage;
  // }

  open(){

    console.log('ttttttttttttttttttttttt');
    console.log(this.currentFeature);
    console.log(this.currentFeature.layerConfig);


    console.log(this.urlOriginIframe);

    const lstParam=this.currentFeature.layerConfig.description.split(".");
    let tableName='';
    let idFieldName='';
    let geom={};

    // if (lstParam.length===2){
    //   tableName=lstParam[0];
    //   idFieldName=lstParam[1];
    // }
    // else{
      var layername="";
      if (this.currentFeature.layerConfig.layername){
        // tableName=this.currentFeature.layerConfig.layername.split(":")[1];
        // idFieldName='gid';
        // geom={
        //   "layer": this.currentFeature.layerConfig.layername.split(":")[1],
        //   "id":  this.currentFeature.get(idFieldName),
        //   "table": tableName, //data_ref4
        //   "gid": this.currentFeature.get(idFieldName),
        //   "geometry": "",
        //   "geojson": "",
        //   "shapeFile": ""
        //   }
        layername=this.currentFeature.layerConfig.layername.split(":")[1];
        if (this.currentFeature.get("libelle")){
          layername=this.currentFeature.get("libelle");
        }
      }
      else{
        layername='dessin';
      }

      var geometry = this.currentFeature.getGeometry();
        var geojson=this.getGeoJSON(this.currentFeature);

        geom=
          {
          "layer": layername,
          "id":  '',
          "table": '', //data_ref4
          "gid": '',
          "geometry": geojson,
          "geojson": geojson,
          "shapeFile": ""
          }

    //}


    //UPDATE LIVRAISON
    window.parent.postMessage([geom], this.urlOriginIframe);
    //window.parent.postMessage([geom], "http://localhost:3000");


  }



  getGeoJSON(feature:any) {
		  var geojson = null;

      let type = '';
      let coords: number[] = [];
      let properties = {};

      let geojson2=null;

      if (feature !== undefined) {
        var geometry=feature.getGeometry();
        if (geometry!== undefined){

          type = geometry.getType();
          coords = geometry.getCoordinates();
          properties = geometry.getProperties();
          console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
          console.log(properties);
          console.log(geojson);
          geojson = {"type": type, "coordinates":coords};


        }


        // const featureCor = feature; // ol.Feature with MultiPolygon
        // const coordsCor = featureCor.getGeometry().getCoordinates();
        // const corrected = correctWinding(coordsCor);
        // feature.getGeometry().setCoordinates(corrected);

        const geojsonFormat = new GeoJSON();
        geojson2 = geojsonFormat.writeFeatureObject(feature);

      }



		  return geojson2.geometry;
		}



}

// function isClockwise(coords: string | any[]) {
//   let sum = 0;
//   for (let i = 0; i < coords.length - 1; i++) {
//     const [x1, y1] = coords[i];
//     const [x2, y2] = coords[i + 1];
//     sum += (x2 - x1) * (y2 + y1);
//   }
//   return sum > 0;
// }

// function correctWinding(multiPolygonCoords: any[][]) {
//   return multiPolygonCoords.map((polygon: any[]) => {
//     return polygon.map((ring, i) => {
//       const ringCopy = ring.slice(); // avoid mutation
//       const shouldBeCCW = i === 0;
//       if (isClockwise(ringCopy) === shouldBeCCW) {
//         return ringCopy.reverse();
//       }
//       return ringCopy;
//     });
//   });
// }

